import { Platform, StyleSheet, View } from 'react-native';
import { ResizeMode } from 'expo-av';

import { Carousel } from '@pletly/ui';
import { useMediaSlider } from './useMediaSlider';
import { Media } from './Media';
import { MediaSliderProps } from './types';

const DEFAULT_DIMENSION = 250;

export const MediaSlider = ({
	style,
	images,
	height = DEFAULT_DIMENSION,
	onLongPress,
}: MediaSliderProps) => {
	const { onLayout, width, onImagePress, media } = useMediaSlider(images);

	return (
		<View onLayout={onLayout} style={style}>
			{width > 0 && (
				<Carousel
					onPress={onImagePress}
					onLongPress={onLongPress}
					width={width}
					height={height}
					data={media}
					mode="parallax"
					modeConfig={{
						parallaxScrollingScale: 1,
						parallaxScrollingOffset: 0,
					}}
					renderItem={({ item, index, activeIndex }) => (
						<Media
							source={item}
							style={[styles.imageComponent, { width }]}
							videoProps={{
								resizeMode: ResizeMode.COVER,
								...(Platform.OS === 'web'
									? { playerVisible: index === activeIndex, autoPlay: true }
									: {}),
							}}
						/>
					)}
				/>
			)}
		</View>
	);
};

const styles = StyleSheet.create({
	imageComponent: {
		overflow: 'hidden',
		flex: 1,
		height: DEFAULT_DIMENSION,
	},
});
